<template lang="html">
  <div class="text-xs-center" >
    <v-dialog
      v-model="dialog"
      width="500">
    
    <!-- button to change the photo / open the popUp -->
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" 
               color="purple darken-4" 
               style="font-size: 8px; outline:none;" 
               @click="analyticOpenPopUpPhoto"
               rounded small
               text>
            {{ $t('LoggedArea.InfoProfile.PhotoPopUp.btnChangePhoto') }}
        </v-btn>
      </template>

      <v-card>
        
         <!-- title popUp -->
        <v-card-title class="purple darken-4 white--text body-2"
                      style="padding-top: 10px; padding-left: 10px;"
                      >
            {{ $t('LoggedArea.InfoProfile.PhotoPopUp.btnUploadPhoto') }}
        </v-card-title>

        <!-- icon to upload the photo -->
        <clipper-upload v-model="imgURL" style="width:100%; height:100%;"
                        @input="rotate=true" >
          <div class="text-center">
            <v-btn class="ma-2" color="purple darken-4 white--text caption" darken-4> {{ $t('LoggedArea.InfoProfile.PhotoPopUp.btnAddPhoto') }}
                <v-icon dark right> mdi-cloud-upload</v-icon>
            </v-btn>
          </div>
        </clipper-upload>

        <!-- container to change the photo's dimensions -->
        <div class="container-photo-cut d-flex flex-column">
            <div> 
              <clipper-fixed style="min-width:100%; min-height:100%; overflow:hidden;" 
                            :ratio="1"
                            :min-scale="1.14"
                            class="my-clipper" ref="clipper" 
                            :area="100" round :src="imgURL"
                            :rotate="rotateAngle">
              </clipper-fixed>
            </div>
            <div class="align-self-center" v-if="rotate">
              <v-btn color="purple darken-4" text>
                <v-icon @click="rotatePhoto">{{ icons.mdiRotateRight }}</v-icon>
              </v-btn>
            </div>
        </div>

        <v-divider style="margin-top:30px; margin-bottom: 0px;" />

        <v-card-actions class="pt-0">

          <v-spacer></v-spacer>

          <!-- button to cancel the upload / close pop-up -->
          <v-btn color="purple darken-4" text
                 @click="dialog=false">
             {{ $t('LoggedArea.InfoProfile.PhotoPopUp.btnCancel') }}
          </v-btn>

           <!-- button to close pop-up after uploading photo -->
          <v-btn color="purple darken-4" text
                 @click="getCanvas">
            {{ $t('LoggedArea.InfoProfile.PhotoPopUp.btnDone') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { auth, storage, analytics } from "@/config/firebaseConfig";
import { clipperUpload, clipperFixed } from "vuejs-clipper";
import { mdiRotateRight } from "@mdi/js";
export default {
  components: { clipperFixed, clipperUpload },
  data() {
    return {
      dialog: false,
      popUpActivate: false,
      imgURL: "",
      icons: {
        mdiRotateRight,
      },
      rotate: false,
      rotateAngle: 0,
    };
  },
  computed: {
    token() {
      return this.$store.state.token;
    },
  },
  methods: {
    analyticOpenPopUpPhoto() {
      analytics.logEvent("Btn_ChgPhoto");
    },
    getCanvas() {
      this.$store.commit("setLoading", true);
      const canvas = this.$refs.clipper.clip();
      this.dialog = false;
      canvas.toBlob(this.canvasToBlob);
    },
    canvasToBlob(blob) {
      const image = new Image();
      image.src = blob;
      if (blob != null) this.savePhoto(blob);
      else this.dialog = false;
    },
    async savePhoto(blob) {
      const extension = blob.type.split("/").pop();

      const fileName = `${auth.currentUser.uid}.${extension}`;

      storage
        .ref(`users/profile/${fileName}`)
        .put(blob)
        .then((response) => {
          response.ref.getDownloadURL().then((link) => {
            const uid = auth.currentUser.uid;
            this.$http.patch(`users/${uid}.json?auth=${this.token}`, {
              photoProfile: link,
            });
            this.$store.commit("changePhotoProfile", link);
            this.beforeUpload = true;
            this.$store.commit("setLoading", false);
          });
        });
      analytics.logEvent("Btn_SavPhoto");
    },
    rotatePhoto() {
      this.rotateAngle = this.rotateAngle <= 270 ? this.rotateAngle + 90 : 90;
      analytics.logEvent("Btn_RotPhoto");
    },
  },
};
</script>
<style>
.container-photo-cut {
  width: 200px;
  height: 200px;
  margin: auto;
}
</style>